export const POSTAL_TYPE_OPTIONS = [
    { label: 'Standard', value: 'STANDARD' },
    { label: 'Express', value: 'EXPRESS' },
];

export const CLIENT_OPTIONS = [
    { value: 'omarket-paid', name: 'Омаркет с подпиской' },
    { value: 'omarket-unpaid', name: 'Омеркет без подписки' },
    { value: 'goszakup', name: 'ГЗ' },
    { value: 'free-order', name: 'Свободный заказ' },
];

export const ACTIVE_OPTIONS = [
    { label: 'Активные', value: true },
    { label: 'Неактивные', value: false },
];
